export type ApiHandlerWithAuth = (
  request: Request,
  checkAuth: () => Promise<void>
) => Promise<Response>;

export type AuthenticationHeaderParams = {
  recaptchaTokenKey: string;
  recaptchaToken: string;
  recaptchaVersionKey: string;
  recaptchaVersion: string;
};

export class HttpError extends Error {
  status: number;
  statusText: string;

  constructor(status: number, message: string, statusText?: string) {
    super(message);
    this.name = "HttpError";
    this.status = status;
    this.statusText = statusText ?? message;
  }
}

export type HttpMethod = "DELETE" | "GET" | "PATCH" | "POST" | "PUT";

export type HttpResult<T> = {
  headers?: Record<string, string>;
  data?: T;
  error?: {
    status?: number;
    message: string;
    details?: string;
  };
};
